<style scoped>
#qrcode-reader {
  color: #fff;
}
#qrcode-reader canvas {
  display: block;
  width: auto;
  max-width: 20rem;
  height: auto;
  max-height: 20rem;
  margin: 0 auto;
}
#qrcode-reader video {
  position: absolute;
  top: -100%;
  opacity: 0;
}
</style>

<template>
  <div id="qrcode-reader">
    <video autoplay playsinline></video>
    <canvas></canvas>
    <div>
      <p class="is-cs-2 has-text-weight-bold has-text-centered">QRコードを枠内に入れてください</p>
    </div>
  </div>
</template>

<script>
import jsQR from 'jsqr'
export default {
  data: () => ({
    medias: {
      audio: false,
      // video: true,
      video: {
        facingMode: {
          exact: 'environment'
        }
      }
    },
    video: null,
    canvas: null,
    context: null,
    stopCamera: false,
    animationId: null,
    stream: null
  }),
  created () {
    console.log('created cachalog-qrcode-reader')
  },
  mounted () {
    this.video = document.querySelector('#qrcode-reader video')
    this.canvas = document.querySelector('#qrcode-reader canvas')
    this.canvas.width = 640
    this.canvas.height = 480
    this.context = this.canvas.getContext('2d')

    const frame = () => {
      this.canvas.width = this.video.videoWidth || this.canvas.width
      this.canvas.height = this.video.videoHeight || this.canvas.width
      this.context.drawImage(this.video, 0, 0)
      const imageData = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height)
      const code = jsQR(imageData.data, imageData.width, imageData.height)
      if (code) {
        console.log('Found QR code', code.data, code)
        if (code.data) {
          this.$store.dispatch('fetchWishlistByUid', code.data)
        }
      } else {
        this.animationId = requestAnimationFrame(frame)
      }
    }
    (async () => {
      this.stream = await navigator.mediaDevices.getUserMedia(this.medias)
      this.video.srcObject = this.stream
      this.animationId = requestAnimationFrame(frame)
    })()
      .catch(error => {
        console.error(error)
        alert('カメラを起動出来ませんでした。')
        this.$router.go(-1)
      })
  },
  destroyed () {
    console.log('shutdown qrcode reader')
    cancelAnimationFrame(this.animationId)
    if (this.stream && this.stream.getVideoTracks) {
      this.stream.getVideoTracks()[0].stop()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view-model/qrcode-reader.vue